var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4993 29.8332C20.1812 29.8332 23.5146 28.3408 25.9274 25.9279C28.3403 23.5151 29.8327 20.1817 29.8327 16.4998C29.8327 12.8179 28.3403 9.48461 25.9274 7.07175C23.5146 4.65889 20.1812 3.1665 16.4993 3.1665C12.8174 3.1665 9.48412 4.65889 7.07126 7.07175C4.6584 9.48461 3.16602 12.8179 3.16602 16.4998C3.16602 20.1817 4.6584 23.5151 7.07126 25.9279C9.48412 28.3408 12.8174 29.8332 16.4993 29.8332Z",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.595 11.2144C17.1209 11.2144 17.5473 11.6408 17.5473 12.1668C17.5473 12.6927 17.1209 13.1191 16.595 13.1191C16.069 13.1191 15.6426 12.6927 15.6426 12.1668C15.6426 11.6408 16.069 11.2144 16.595 11.2144Z",
    fill: "#403B37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8332 21.2148V14.5482H16.357H15.8809",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.166 21.215H18.4993",
    stroke: "#403B37",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c85b70f26b22fd6bfa0f13fbdcd09b8c.svg";
export { ForwardRef as ReactComponent };